<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm_head">Contents</h2>
<p class="con"><a href="#/text/9780062856616_Cover#cover" id="rcover"><i>Cover</i></a></p>
<p class="con"><a href="#/text/9780062856616_Titlepage#title" id="rtitle"><i>Title Page</i></a></p>
<p class="con"><a href="#/text/9780062856616_Dedication#_idParaDest-1" id="r_idParaDest-1"><i>Dedication</i></a></p>
<p class="con1"><a href="#/text/9780062856616_Chapter_1#_idParaDest-3" id="r_idParaDest-3">The Border Fox</a></p>
<p class="con"><a href="#/text/9780062856616_Chapter_2#_idParaDest-4" id="r_idParaDest-4">The Boatman</a></p>
<p class="con"><span href="#/text/9780062856616_Chapter_3#_idParaDest-5" id="r_idParaDest-5" title="Link target outside of Sample">Ruins</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_4#_idParaDest-6" id="r_idParaDest-6" title="Link target outside of Sample">Beginish</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_5#_idParaDest-7" id="r_idParaDest-7" title="Link target outside of Sample">Love is Strange</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_6#_idParaDest-8" id="r_idParaDest-8" title="Link target outside of Sample">A Sense of Rain</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_7#_idParaDest-9" id="r_idParaDest-9" title="Link target outside of Sample">Wildflowers</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_8#_idParaDest-10" id="r_idParaDest-10" title="Link target outside of Sample">Segovia</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_9#_idParaDest-11" id="r_idParaDest-11" title="Link target outside of Sample">The Aftermath</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_10#_idParaDest-12" id="r_idParaDest-12" title="Link target outside of Sample">Fine Feathers</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_11#_idParaDest-13" id="r_idParaDest-13" title="Link target outside of Sample">Last Christmas</span></p>
<p class="con"><span href="#/text/9780062856616_Chapter_12#_idParaDest-14" id="r_idParaDest-14" title="Link target outside of Sample">A Death in the Family</span></p>
<p class="con1"><span href="#/text/9780062856616_Acknowledgements#_idParaDest-15" id="r_idParaDest-15" title="Link target outside of Sample"><i>Acknowledgements</i></span></p>
<p class="con"><span href="#/text/About_the_Author#_idParaDest-16" id="r_idParaDest-16" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="con"><span href="#/text/9780062856616_Also_by#_idParaDest-17" id="r_idParaDest-17" title="Link target outside of Sample"><i>Also by Billy O’Callaghan</i></span></p>
<p class="con"><span href="#/text/9780062856616_Copyright#_idParaDest-19" id="r_idParaDest-19" title="Link target outside of Sample"><i>Copyright</i></span></p>
<p class="con"><span href="#/text/About_the_Publisher#_idParaDest-20" id="r_idParaDest-20" title="Link target outside of Sample"><i>About the Publisher</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062856616_Contents.vue?39f86d6c